/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Practical_Experience_InstructionsInputs */

const en_practical_experience_instructions = /** @type {(inputs: Practical_Experience_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Provide a separate entry for each experience. Write <b>briefly and concretely</b> (3-6 sentences or bullet points) and include:<br/>- Role, organization, location, <b>time period</b><br/>- Tasks and responsibilities<br/>- Tools/methods used<br/>- <b>Results with numbers</b> (e.g., "Processing time −25%")<br/>- Most important learnings/soft skills applied`)
};

const de_practical_experience_instructions = /** @type {(inputs: Practical_Experience_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geben Sie pro Erfahrung einen eigenen Eintrag an. Schreiben Sie <b>kurz und konkret</b> (3–6 Sätze oder Stichpunkte) und nennen Sie:<br/>- Rolle, Organisation, Ort, <b>Zeitraum</b><br/>- Aufgaben und Verantwortungen<br/>- eingesetzte Tools/Methoden<br/>- <b>Ergebnisse mit Zahlen</b> (z. B. "Bearbeitungszeit −25 %")<br/>- wichtigste Lerngewinne/Soft Skills im Einsatz`)
};

/**
* | output |
* | --- |
* | "Provide a separate entry for each experience. Write <b>briefly and concretely</b> (3-6 sentences or bullet points) and include:<br/>- Role, organization, loc..." |
*
* @param {Practical_Experience_InstructionsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const practical_experience_instructions = /** @type {((inputs?: Practical_Experience_InstructionsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practical_Experience_InstructionsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_practical_experience_instructions(inputs)
	return en_practical_experience_instructions(inputs)
});